import { RootStoreContext as RootStoreCommonContext } from '@gimlite/common/hooks/useStore.hook';
import { RootStoreMobX as RootCommonStoreMobX } from '@gimlite/common/stores/root.store';
import { createContext, useContext } from 'react';
import { RootStoreMobX } from '../stores/root.store';
export function useStoreUIV2() {
  const context = useContext(RootStoreContext);

  const { ...contextCommon } = useContext<RootCommonStoreMobX>(
    RootStoreCommonContext,
  );
  if (context === undefined) {
    throw new Error('useRootStore must be used within RootStoreProvider');
  }

  return { ...context, ...contextCommon };
}

export const RootStoreContext = createContext<RootStoreMobX | undefined>(
  undefined,
);
